import IndexedDbCache from '@/services/IndexedDbCache/IndexedDbCache'
import type { IReactiveCache } from '@/services/IndexedDbCache/IIndexedDbCache'
import type { ILastMessages, IMessage } from '@/store/messages/interfaces'

const DB_NAME = 'last-message-cache'
const STORE_NAME = 'lastMessage'
const DB_VERSION = 1

export interface ILastMessageRow {
  jid: string
  message: IMessage
}

export interface ILastMessagesCache extends IReactiveCache<ILastMessageRow> {
  getMessage(jid: string): IMessage | undefined
  getAllMessages(): ILastMessages
  putMessages(messages: ILastMessages): void
}

class LastMessagesCache extends IndexedDbCache<ILastMessageRow> implements ILastMessagesCache {
  constructor() {
    super({ dbName: DB_NAME, storeName: STORE_NAME, keyPath: 'jid', version: DB_VERSION })
  }

  getMessage(jid: string): IMessage | undefined {
    return this.getSnapshot(jid)?.message
  }

  getAllMessages(): ILastMessages {
    const rows = this.getAll()
    const result: ILastMessages = {}
    for (const jid in rows) {
      const row = rows[jid]
      if (row) {
        result[jid] = row.message
      }
    }
    return result
  }

  putMessages(messages: ILastMessages) {
    const rows = Object.entries(messages).map(([jid, message]) => ({ jid, message }))
    this.putMany(rows)
  }
}

export default LastMessagesCache
